import { Outlet, useNavigate, useParams } from 'react-router-dom';

import { usePractices } from 'lib/hooks/queries/practice/usePractices';
import usePageTitle from 'lib/hooks/usePageTitle';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';

import { COLUMN_DEFS, FILTERS_DEFS } from './lib/helpers';

const PracticesTable = () => {
  usePageTitle('Practices');
  const { id } = useParams();
  const navigate = useNavigate();
  const onSelectRow = ({ id }) => {
    if (id) {
      navigate(`/admin/practices/${id}`);
    }
  };
  if (id) {
    return <Outlet />;
  }
  return (
    <AgTablePage
      useData={usePractices}
      defaultColumns={COLUMN_DEFS}
      defaultFilters={FILTERS_DEFS}
      name="practices"
      onSelectRow={onSelectRow}
      queryParams={{ withCount: true }}
    />
  );
};

export default withErrorBoundary(PracticesTable);
